import React from 'react';
import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import type { Comparison } from '../../../types/BaselineMeasurements';
import type { UseQueryWrapper } from '../../../types';
import { baselineMeasurementService } from '../../../Domain/BaselineMeasurements/Services';

import { useSnakeBar } from '../../useSnakeBar';

type GetComparisonQueryVariables = Partial<Pick<Comparison, 'comparisonId'>>;
export type GetComparisonQueryResultData = Comparison;

const QUERY_KEY = 'getBaselineMeasurementComparison';

const queryFn = (variables: GetComparisonQueryVariables) => async () => {
  if (variables?.comparisonId) {
    const response = await baselineMeasurementService.getComparison(variables.comparisonId);
    return (response as AxiosResponse).data;
  }
};

export const useBaselineMeasurementsGetComparisonQuery: UseQueryWrapper<
  GetComparisonQueryResultData,
  GetComparisonQueryVariables
> = ({ variables, options }) => {
  const { showErrorSnakeBar } = useSnakeBar();
  const onError = React.useCallback(() => {
    showErrorSnakeBar({ method: QUERY_KEY });
  }, [showErrorSnakeBar]);

  return useQuery<GetComparisonQueryResultData>([QUERY_KEY], queryFn(variables), {
    onError,
    ...(options || {}),
  });
};
